/*********************************************************************
**********************************************************************
Utility Classes which can be used across website
**********************************************************************
*********************************************************************/
import cssVar from './variables';
const utility = {
	posRel: `
    position: relative;
  `,
	txtC: `
    text-align: center;
  `,
	txtR: `
    text-align: right;
  `,
	txtL: `
    text-align: left;
  `,
	txtLowerCase: `
    text-transform: lowercase;
  `,
	txtUnderline: `
    text-decoration: underline;
  `,
	txtCapitalize: `
    text-transform: capitalize;
  `,
	txtLineThrough: `
    text-decoration: line-through;
  `,
	txtUpperCase: `
    text-transform: uppercase;
  `,
	h1: `
    font-size: ${cssVar.h1};
  `,
	h2: `
    font-size: ${cssVar.h2};
  `,
	h3: `
    font-size: ${cssVar.h3};
  `,
	h4: `
    font-size: ${cssVar.h4};
  `,
	h5: `
    font-size: ${cssVar.h5};
  `,
	h6: `
    font-size: ${cssVar.h6};
  `,
	fontL: `
    font-size: ${cssVar.fontL};
  `,
	fontM: `
    font-size: ${cssVar.fontM};
  `,
	fontS: `
    font-size: ${cssVar.fontS};
  `,
	fontXs: `
    font-size: ${cssVar.fontXs};
  `,
	fontMini: `
    font-size: ${cssVar.fontMini};
  `,
	fontMicro: `
    font-size: ${cssVar.fontMicro};
  `,
  fontEatsurance: `
    font-size: ${cssVar.fontEatsurance};
  `,
	fontCaption: `
    font-size: ${cssVar.fontCaption};
  `,
	flex: `
    display: flex !important;
  `,
	inlineFlex: `
    display: inline-flex;
  `,
	flexR: `
    flex-direction: row;
  `,
	flexRR: `
    flex-direction: row-reverse;
  `,
	flexC: `
    flex-direction: column;
  `,
	flexCR: `
    flex-direction: column-reverse;
  `,
	flexWrapN: `
    flex-wrap: nowrap;
  `,
	flexWrapW: `
    flex-wrap: wrap;
  `,
	flexWrapWR: `
    flex-wrap: wrap-reverse;
  `,
	justifyContentFE: `
    justify-content: flex-end;
  `,
	justifyContentFS: `
    justify-content: flex-start;
  `,
	justifyContentC: `
    justify-content: center !important;
  `,
	justifyContentSA: `
    justify-content: space-around;
  `,
	justifyContentSB: `
    justify-content: space-between;
  `,
	alignItemFS: `
    align-items: flex-start;
  `,
	alignItemC: `
    align-items: center !important;
  `,
	alignItemFE: `
    align-items: flex-end;
  `,
	alignItemS: `
    align-items: stretch;
  `,
	flexShrink0: `
    flex-shrink: 0;
  `,
	alignItemB: `
    align-items: baseline;
  `,
	cardShadow: `
    box-shadow: 0 0 16px 0 rgb(0 0 0 / 8%);
  `,
	cardPadding: `
    padding: 1rem;
  `,
	textEllipsis: `
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  `,
	marginReset: `
    margin: 0;
  `,
	paddingReset: `
    padding: 0;
  `,
	boxCenter: `
    display: flex;
    align-items: center;
    justify-content: center;
  `,
	loader: `
    ::after{
        content: '';
        background-color: #424242;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(to right,rgba(255,255,255,0) 0,rgba(255,255,255,.6) 30%,rgba(255,255,255,0) 81%);
    }
  `,
	txtSeparator: `
    margin: ${cssVar.spacingXxxs} 0;
    &::before{
      content: 'Or';
      font-size: ${cssVar.fontMini};
      color: ${cssVar.color6};
    }
  `,
	stickyPosition:`
    position: sticky;
    top: -1px;
    z-index: 98;
  `,
}
export default utility;